import { useEffect } from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { ArrowRight } from 'lucide-react';

export default function RoofingGreen() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />

      {/* HERO */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="relative h-[600px] mb-0 overflow-hidden"
      >
        <img
          src="https://media.base44.com/images/public/69db395aa041ab4d87ab84d7/720bf7692_GreenRoof.jpg"
          alt="Grønt tak"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/10 to-black/20"></div>
        <div className="absolute inset-0 flex flex-col justify-end p-12 z-10">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <p className="text-sm tracking-widest-2xl font-body uppercase text-white/60 mb-6">Artikkel 1</p>
            <h1 className="font-heading text-6xl md:text-7xl lg:text-8xl font-light leading-[1.0] text-white mb-6">
              Grønt tak
            </h1>
            <p className="font-body text-white/80 text-2xl max-w-2xl leading-relaxed">
              Mykt, landskapsnært og dempet, integrasjon med naturen
            </p>
          </motion.div>
        </div>
      </motion.div>

      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <motion.section
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="py-20"
        >
          <div className="max-w-4xl">
            <h2 className="font-heading text-5xl font-light leading-[1.1] mb-8 text-[#2a1810]">
              Taket som blir en del av landskapet
            </h2>
            <p className="font-body text-2xl text-foreground/70 leading-relaxed mb-6">
              Grønt tak er for deg som ønsker at badstuen skal ligge lavt og gli stille inn i naturomgivelsene. Det gir bygget en mykere avslutning og skaper en visuell binding til landskapet.
            </p>
            <p className="font-body text-2xl text-foreground/70 leading-relaxed mb-12">
              I stedet for å oppstå som et distinkt volum, blir badstuen en del av terrenget. Spesielt effektivt på steder med fine utsikter — taket «forsvinner» mens bygget åpner seg ut mot landskapet.
            </p>

            <div className="grid md:grid-cols-2 gap-6 mb-16">
              {[
                { 
                  title: 'Integrert design',
                  desc: 'Badstuen blir en fortsettelse av landskapet, ikke en kontrast til det. Det skaper visuell harmoni.' 
                },
                { 
                  title: 'Økologisk verdi',
                  desc: 'Grønt tak støtter insekter, fugler og andre små økosystemer. En fin tillegg til et naturvennlig prosjekt.' 
                },
                { 
                  title: 'Temperaturregulering',
                  desc: 'Vegetasjonen demper temperatursvingninger og gir både isolasjon og kjøling over året.' 
                },
                { 
                  title: 'Sesongvis oppfølging',
                  desc: 'Du vil trenge å sjekke drenering og vedlikeholde vegetasjonen — ikke tungt arbeid, men regelmessigt.' 
                }
              ].map((item, idx) => (
                <motion.div
                  key={idx}
                  whileHover={{ y: -4 }}
                  className="bg-white border border-border/20 rounded-[8px] p-8 hover:border-[#2d5a3d] hover:shadow-md transition-all"
                >
                  <h3 className="font-heading text-2xl font-light text-[#2a1810] mb-3">{item.title}</h3>
                  <p className="font-body text-2xl text-foreground/70">{item.desc}</p>
                </motion.div>
              ))}
            </div>

            <div className="bg-gradient-to-br from-[#2d5a3d]/10 to-transparent border-l-4 border-[#2d5a3d] rounded-[8px] p-8 mb-12">
              <h3 className="font-heading text-2xl font-light text-[#2a1810] mb-3">Ideelt for:</h3>
              <ul className="space-y-2 font-body text-2xl text-foreground/70">
                <li>• Prosjekter i naturlige omgivelser</li>
                <li>• Steder med fine utsikter (taket skal ikke dominere visuelt)</li>
                <li>• Der du ønsker maksimal integrasjon med landskapet</li>
                <li>• Klima med jevn nedbør og ikke ekstremt varmt eller kaldt</li>
              </ul>
            </div>

            <motion.a
              whileHover={{ scale: 1.02 }}
              href="/laer-mer-handverk"
              className="inline-flex items-center gap-2 px-8 py-4 bg-[#2a1810] text-white font-body tracking-widest text-2xl font-semibold rounded-[4px] hover:bg-[#2a1810]/90 transition-all"
            >
              Tilbake til Lær Mer <ArrowRight size={16} />
            </motion.a>
          </div>
        </motion.section>
      </div>

      <Footer />
    </div>
  );
}